import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import BlogCard, { IBlogCard } from "@/components/cards/BlogCard";

// ---------------------------------------------------------------------------------------------

export type IFeaturedBlogsSectionProps = HTMLAttributes<HTMLElement> & {
  showMoreBlogs?: boolean;
  blogs?: (IBlogCard & { link: string })[];
};

const FeaturedBlogsSection: FC<IFeaturedBlogsSectionProps> = (props) => {
  const { blogs, showMoreBlogs, className, ...other } = props;

  // remove first element
  const restElements = blogs && blogs.length > 0 && blogs.slice(1);

  return (
    <section
      className={clsx("container py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div
        className={clsx(
          showMoreBlogs
            ? "w-full"
            : "grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8",
        )}
      >
        {blogs && blogs.length > 0 && (
          <BlogCard
            figureWrapperClass="h-auto lg:h-[239px] xl:h-[356px] w-full"
            link={blogs[0].link}
            image={blogs[0].image}
            imageClass="w-full"
            publishDate={blogs[0].publishDate}
            readingTime={blogs[0].readingTime}
            heading={blogs[0].heading}
            description={showMoreBlogs && blogs[0].description}
            author={blogs[0].author}
            contentWrapperClass={clsx(
              "!pb-0 !pt-6",
              showMoreBlogs && "col-span-full !px-0 lg:col-span-6",
            )}
            figureClass={clsx(
              showMoreBlogs && "col-span-full flex items-center lg:col-span-6",
            )}
            className={clsx(
              showMoreBlogs &&
                "grid grid-cols-6 gap-5 lg:grid-cols-12 lg:gap-7",
            )}
            showReadArticleButton={showMoreBlogs}
          />
        )}

        {restElements && restElements.length > 0 && !showMoreBlogs && (
          <div className="flex flex-col gap-6 lg:gap-10 xl:gap-[58px]">
            {restElements.map((item) => (
              <BlogCard
                link={item.link}
                key={item.link}
                publishDate={item.publishDate}
                readingTime={item.readingTime}
                heading={item.heading}
                author={item.author}
                contentWrapperClass="!py-0"
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturedBlogsSection;
